import './NASUSessionCard.scss';

import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import BaseCard from 'components/shared/Card/BaseCard';
import {
  getInprogressCount,
  getInProgress
} from 'components/shared/ErrorPage/NasuStateSelector';
import NasuDeleteServiceJourneyModal from 'components/shared/Modal/ReturnJourneyDeleteModal';
import { nasuAccountsLink, nasuAccountLinkV2 } from 'services/Externals';
import { hasAlaska529Only, isDesktopLayout } from 'state/view/ViewSelectors';
import { nasuInprogressReturnJourneyTile } from 'services/FeatureFlags';
import { deleteInProgressApplicationsV2 } from 'services/Rest';
import { ReactComponent as Bell } from 'assets/icons/bell.svg';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import trashCan from 'assets/icons/trash-can.svg';
import { dayDifference, mmddyyyy } from 'services/Dates';
import moment from 'moment';

const NASUSessionCard = ({
  nasuApplicationsCount,
  hasAlaska529Only,
  nasuReturnJourney,
  isDesktopLayout,
  requestStatus
}) => {
  const pluralize = (word, count) => (count === 1 ? word : word + 's');

  //if NASU_INPROGRESS_RETURN_JOURNEY_TILE is truecancelConfirmation Modal
  //show updated NASU return Journey tile and inprogress/v2 call
  const [failedCounter, setFailedCounter] = useState(0);
  let receivedDeleteSuccess =
    requestStatus['deleteInProgressApplication'] === REQUEST_STATES.received;
  let receivedDeleteError =
    requestStatus['deleteInProgressApplication'] === REQUEST_STATES.error;

  if (nasuInprogressReturnJourneyTile()) {
    if (!nasuReturnJourney) {
      return null;
    } else {
      //inprogress returns as an empty object at first
      return (
        <>
          {nasuReturnJourney?.map((returnJourneyTileInfo, i) => {
            const creationDate = mmddyyyy(
              returnJourneyTileInfo.createDate,
              '/',
              true
            );
            const dayCount = dayDifference(
              returnJourneyTileInfo.expirationDate,
              moment.utc()
            );
            const daysToExpiration = dayCount <= 1 ? 1 : dayCount;
            return (
              <BaseCard
                title={null}
                id={'nasu-card-' + i}
                key={i}
                isLoading={null}
                footer={null}
                className="nasu nasu-card-container">
                <div className={'nasu-card-body'}>
                  <div className="top">
                    <div className="nasu-inprogress-title-v2">
                      <a
                        href={nasuAccountLinkV2(
                          returnJourneyTileInfo?.applicationID
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        id={
                          'return-journey-URL-to-nasu-account' +
                          returnJourneyTileInfo?.applicationID
                        }
                        role={'link'}
                        className={classnames('action no-underline', {
                          alaska: hasAlaska529Only
                        })}>
                        Complete your {returnJourneyTileInfo?.accountDisplay}{' '}
                        application
                      </a>
                    </div>
                  </div>
                  <div className="bottom-v2">
                    <p className="nasu-inprogress-body-v2">
                      You started opening an account on <b>{creationDate}</b>.
                      Your application will automatically delete in{' '}
                      <b>{daysToExpiration}</b>{' '}
                      {pluralize('day', daysToExpiration)}.
                    </p>
                  </div>
                </div>
                <DeleteModal
                  size={isDesktopLayout ? 'medium' : 'jumbo'}
                  icon={<img slot="icon" src={trashCan} alt="Trash Can IMG" />}
                  closeOnClickOut={false}
                  defaultIconSizing
                  ctaButtons
                  requestStatus={requestStatus}
                  failedCounter={failedCounter}
                  setFailedCounter={setFailedCounter}
                  CTA={() =>
                    deleteInProgressApplicationsV2(
                      returnJourneyTileInfo?.applicationID,
                      returnJourneyTileInfo?.accountDisplay
                    )
                  }
                  leftButtonVariant={'tertiary'}
                  leftButtonLabel={'Cancel'}
                  leftButtonScale={'jumbo'}
                  rightButtonVariant={'negative'}
                  rightButtonLabel={
                    receivedDeleteError && failedCounter > 0
                      ? 'Try Again'
                      : 'Delete'
                  }
                  rightButtonScale={'jumbo'}
                  receivedDeleteSuccess={receivedDeleteSuccess}
                  receivedDeleteError={receivedDeleteError}>
                  <>
                    {receivedDeleteError && failedCounter > 0 && (
                      <>
                        <div className="nasu-modal-tile">
                          Something went Wrong
                        </div>
                        <NasuDeleteServiceJourneyModal
                          createDate={returnJourneyTileInfo?.createDate}
                          accountDisplay={returnJourneyTileInfo?.accountDisplay}
                          receivedDeleteError={receivedDeleteError}
                          failedCounter={failedCounter}
                        />
                      </>
                    )}
                    {(!receivedDeleteError || failedCounter === 0) && (
                      <>
                        <div className="nasu-modal-tile">Are you sure?</div>
                        <NasuDeleteServiceJourneyModal
                          createDate={creationDate}
                          accountDisplay={returnJourneyTileInfo?.accountDisplay}
                          receivedDeleteError={receivedDeleteError}
                          failedCounter={failedCounter}
                        />
                      </>
                    )}
                  </>
                </DeleteModal>
              </BaseCard>
            );
          })}
        </>
      );
    }
  } else {
    if (!nasuApplicationsCount || nasuApplicationsCount === 0) {
      return null;
    }
    return (
      <BaseCard
        title={null}
        isLoading={null}
        footer={null}
        className="standard nasu-card-container">
        <div className="top">
          <Bell className="nasu-icon" />
          <h3 className="title">Account applications in progress</h3>
        </div>
        <div className="bottom">
          <p>
            You currently have {nasuApplicationsCount} new account{' '}
            {pluralize('application', nasuApplicationsCount)} in progress.
          </p>
          <a
            href={nasuAccountsLink}
            target="_blank"
            rel="noopener noreferrer"
            className={classnames('action no-underline', {
              alaska: hasAlaska529Only
            })}>
            View {pluralize('Application', nasuApplicationsCount)}
          </a>
        </div>
      </BaseCard>
    );
  }
};

const mapStateToProps = (state) => ({
  nasuApplicationsCount: getInprogressCount(state),
  hasAlaska529Only: hasAlaska529Only(state),
  nasuReturnJourney: getInProgress(state),
  isDesktopLayout: isDesktopLayout(state),
  requestStatus: getRequestStatus(state)
});

export default connect(mapStateToProps)(NASUSessionCard);
